module.exports = __webpack_public_path__ + "static/media/boardgames.48aed997.png";